<template>
  <div v-if="hasExchangeCars" class="vcr-page__section">
    <h2 class="vcr-page__header">{{ i18n.t('/Vcr/Exchange Car/Title') }}</h2>

    <div class="vcr-exchange-car__table">
      <!-- Header Row -->
      <div v-if="isCanAddMultipleExchangeCars" class="vcr-exchange-car__header-row">
        <div class="vcr-exchange-car__label-col"></div>
        <div v-for="(car, index) in exchangeCars" :key="index" class="vcr-exchange-car__car-col">
          <strong>{{ i18n.t('/Vcr/Exchange Car/Car ' + (index + 1)) }} </strong>
        </div>
      </div>

      <!-- Data Rows -->
      <div class="vcr-exchange-car__row">
        <div class="vcr-exchange-car__label">{{ i18n.t('/Vcr/Exchange Car/Car Type Label') }}</div>
        <div v-for="(car, index) in exchangeCars" :key="index" class="vcr-exchange-car__value">
          {{ car.Type }}
        </div>
      </div>

      <div class="vcr-exchange-car__row">
        <div class="vcr-exchange-car__label">
          {{ i18n.t('/Vcr/Exchange Car/License Plate Label') }}
        </div>
        <div v-for="(car, index) in exchangeCars" :key="index" class="vcr-exchange-car__value">
          {{ car.LicensePlate }}
        </div>
      </div>

      <div class="vcr-exchange-car__row">
        <div class="vcr-exchange-car__label">{{ i18n.t('/Vcr/Exchange Car/Brand Label') }}</div>
        <div v-for="(car, index) in exchangeCars" :key="index" class="vcr-exchange-car__value">
          {{ car.BrandName }}
        </div>
      </div>

      <div class="vcr-exchange-car__row">
        <div class="vcr-exchange-car__label">{{ i18n.t('/Vcr/Exchange Car/Model Label') }}</div>
        <div v-for="(car, index) in exchangeCars" :key="index" class="vcr-exchange-car__value">
          {{ car.ModelName }}
        </div>
      </div>

      <div class="vcr-exchange-car__row">
        <div class="vcr-exchange-car__label">{{ i18n.t('/Vcr/Exchange Car/Milage Label') }}</div>
        <div v-for="(car, index) in exchangeCars" :key="index" class="vcr-exchange-car__value">
          {{ car.Mileage }}
        </div>
      </div>

      <div class="vcr-exchange-car__row">
        <div class="vcr-exchange-car__label">
          {{ i18n.t('/Vcr/Exchange Car/Trade In Value Label') }}
        </div>
        <div v-for="(car, index) in exchangeCars" :key="index" class="vcr-exchange-car__value">
          {{ i18n.n(car.TradeValue, 'currency') }}
        </div>
      </div>

      <div class="vcr-exchange-car__row">
        <div class="vcr-exchange-car__label">
          {{ i18n.t('/Vcr/Exchange Car/Price Incl Label') }}
        </div>
        <div v-for="(car, index) in exchangeCars" :key="index" class="vcr-exchange-car__value">
          {{ i18n.n(car.Price?.Incl, 'currency') }}
        </div>
      </div>

      <div class="vcr-exchange-car__row">
        <div class="vcr-exchange-car__label">
          {{ i18n.t('/Vcr/Exchange Car/Price Excl Label') }}
        </div>
        <div v-for="(car, index) in exchangeCars" :key="index" class="vcr-exchange-car__value">
          {{ i18n.n(car.Price?.Excl, 'currency') }}
        </div>
      </div>

      <div class="vcr-exchange-car__row">
        <div class="vcr-exchange-car__label">{{ i18n.t('/Vcr/Exchange Car/Vat Label') }}</div>
        <div v-for="(car, index) in exchangeCars" :key="index" class="vcr-exchange-car__value">
          {{ i18n.n(car.Price?.Btw, 'currency') }}
        </div>
      </div>

      <div class="vcr-exchange-car__row">
        <div class="vcr-exchange-car__label">{{ i18n.t('/Vcr/Exchange Car/Vat Rate Label') }}</div>
        <div v-for="(car, index) in exchangeCars" :key="index" class="vcr-exchange-car__value">
          {{ car.Price?.BtwRate }}%
        </div>
      </div>

      <div class="vcr-exchange-car__row">
        <div class="vcr-exchange-car__label">
          {{ i18n.t('/Vcr/Exchange Car/Bpm Rest Value Label') }}
        </div>
        <div v-for="(car, index) in exchangeCars" :key="index" class="vcr-exchange-car__value">
          {{ i18n.n(car.ResidualBpm, 'currency') }}
        </div>
      </div>

      <div class="vcr-exchange-car__row">
        <div class="vcr-exchange-car__label">
          {{ i18n.t('/Vcr/Exchange Car/Trade In Date Label') }}
        </div>
        <div v-for="(car, index) in exchangeCars" :key="index" class="vcr-exchange-car__value">
          {{ car.ExchangeDate }}
        </div>
      </div>

      <div class="vcr-exchange-car__row">
        <div class="vcr-exchange-car__label">
          {{ i18n.t('/Vcr/Exchange Car/Admission Date Label') }}
        </div>
        <div v-for="(car, index) in exchangeCars" :key="index" class="vcr-exchange-car__value">
          {{ car.AdmissionDate }}
        </div>
      </div>

      <div class="vcr-exchange-car__row">
        <div class="vcr-exchange-car__label">
          {{ i18n.t('/Vcr/Exchange Car/Commercial Vehicle Label') }}
        </div>
        <div v-for="(car, index) in exchangeCars" :key="index" class="vcr-exchange-car__value">
          {{ car.CommercialVehicle }}
        </div>
      </div>

      <div class="vcr-exchange-car__row">
        <div class="vcr-exchange-car__label">{{ i18n.t('/Vcr/Exchange Car/Remarks Label') }}</div>
        <div v-for="(car, index) in exchangeCars" :key="index" class="vcr-exchange-car__value">
          {{ car.Remark }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
    }
  },
  computed: {
    ...mapGetters({
      exchangeCars: 'quote/exchangeCars',
      hasExchangeCars: 'quote/hasExchangeCars',
      dealerSettings: 'user/dealerSettings',
    }),
    isCanAddMultipleExchangeCars() {
      return this.dealerSettings.isCanAddMultipleExchangeCars
    },
  },
}
</script>

<style lang="scss" scoped>
.vcr-exchange-car {
  &__table {
    display: table;
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 20px;
  }

  &__header-row {
    display: table-row;
    font-weight: bold;

    > div {
      display: table-cell;
      padding: 0.75em;
      background-color: #f5f5f5;
      border: 1px solid #dae2e5;
      text-align: center;
    }
  }

  &__row {
    display: table-row;

    &:nth-child(even) {
      background-color: #fafafa;
    }
  }

  &__label-col {
    width: 25%;
  }

  &__car-col {
    width: 25%;
  }

  &__label {
    display: table-cell;
    padding: 0.5em;
    border: 1px solid #dae2e5;
    font-weight: 500;
    background-color: #f9f9f9;
    width: 25%;
  }

  &__value {
    display: table-cell;
    padding: 0.5em;
    border: 1px solid #dae2e5;
    width: 25%;
  }
}
</style>
